export default __webpack_public_path__ + "bfa07809f5ab42a37fae6c5f69eb4196.svg";